/**
 * Prepend currently playing track from websocket without duplicating
 * if it is already first in the playlist chart list.
 *
 * @param {Array<Record<string, mixed>>|null|undefined} trackList
 * @param {Record<string, mixed>} song
 * @returns {Array<Record<string, mixed>>}
 */
export default function prependPlaylistLastSong(trackList, song) {
  if (!song?.id) {
    return Array.isArray(trackList) ? trackList : [];
  }

  const list = Array.isArray(trackList) ? trackList : [];
  const entry = {
    ...song,
    play_date: new Date().toISOString(),
    play_time: new Date().toISOString(),
  };

  if (list[0]?.id === song.id) {
    return [entry, ...list.slice(1)];
  }

  return [entry, ...list];
}
